// extracted by mini-css-extract-plugin
module.exports = {"signInMobileLabel":"az_mMc","fixedSignInMobileIconAndLabel":"az_nMc","signInIcon":"az_oMc"};